import { RouteConfig } from 'vue-router'

const List = () => import('../views/sport-record/List.vue')
const RecordList = () => import('../views/sport-record/RecordList.vue')

export const listRoute: RouteConfig = {
  path: 'sport-record/list',
  name: 'tus_sport_record_list',
  component: RecordList,
  props: (route: any) => ({ ...route.query, ...route.params }),
  meta: {
    title: '',
  },
}

export const exchangeListRoute: RouteConfig = {
  path: 'sport-record/exchange-list',
  name: 'tus_sport_record_exchange_list',
  component: List,
  props: (route: any) => ({ ...route.query, ...route.params }),
  meta: {
    title: '',
  },
}
export default [listRoute, exchangeListRoute]
